/* eslint-disable react-hooks/exhaustive-deps */
import { NotificationsOutlined } from '@mui/icons-material'
import { Alert, AlertTitle, Badge, Button, Divider, Typography } from '@mui/material'
import { Box, Stack } from '@mui/system'
import { numericElementMap } from 'common/libs/numericMap'
import i18n from 'lang/idiomas'
import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { NotificationsSkeleton } from '../pages/NotificationsPage'
import { NotificationsContext } from '../providers/NotificationsProvider'
import NotificationCard from './NotificationsCard'

/**
 * @module Notifications
 */

/**
 * The Menu to show the notifications on the header
 * @component
 *
 * @param {Object} props
 * @param {function} [props.closePopup]
 * @returns {JSX.Element}
 */
const HeaderNotifications = ({ closePopup = () => {} }) => {
  // const {  } = useFetchNotifications({ page: 1, page_size: 6 })
  const { forceRefresh, count, response, loading, error } = useContext(NotificationsContext)

  useEffect(() => {
    forceRefresh()
  }, [])

  const navigate = useNavigate()
  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        width: {
          xs: '100%',
          sm: '40vw',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxSizing: 'border-box',
          mb: 1,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: {
              xs: '1.3em',
              // md: '2em',
            },
            fontWeight: 'bold',
          }}
        >
          {i18n.t('notifica', { defaultValue: 'Notificaciones' })}
        </Typography>
        <Box sx={{}}>
          <Badge badgeContent={0}>
            <NotificationsOutlined
              style={{
                width: '100%',
              }}
            />
          </Badge>
        </Box>
      </Box>
      <Stack spacing={2}>
        <Divider sx={{ mb: 1 }} />
        {response?.results && !loading ? (
          response.results.map((document, idx) => (
            <NotificationCard key={idx} notification={document} closePopup={closePopup} />
          ))
        ) : (
          <></>
        )}
        {!loading && response?.results?.length <= 0 ? (
          <Box sx={{ p: 2 }}>
            <Typography
              variant="h1"
              sx={{ opacity: 0.3, fontSize: '1.5em', fontWeight: 'bold', textAlign: 'center' }}
            >
              {i18n.t('nonotpdt', { defaultValue: 'No hay notificaciones pendientes' })}
            </Typography>
          </Box>
        ) : (
          <></>
        )}
        {loading ? (
          <>
            {numericElementMap(count && count > 5 ? 5 : count, NotificationsSkeleton, () => {
              return {
                width: 50 + Math.ceil(Math.random() * 30),
                reverse: true,
              }
            })}
          </>
        ) : (
          <></>
        )}
        {error && !loading ? (
          <Alert severity="error">
            <AlertTitle>{i18n.t('errconex', { defaultValue: 'Error de conexión' })}</AlertTitle>
            {i18n.t('noobnot', { defaultValue: 'No se han podido obtener las notificaciones' })}
          </Alert>
        ) : (
          <></>
        )}
        <Button
          sx={{ mt: 2, display: 'block', width: '100%' }}
          disableElevation
          color="primary"
          variant="text"
          onClick={() => {
            closePopup()
            navigate('/notificaciones')
          }}
        >
          {i18n.t('vertonot', { defaultValue: 'Ver todas las Notificaciones' })}
        </Button>
      </Stack>
    </Box>
  )
}

export default HeaderNotifications
